import React from 'react';

import { SingleTeamSelectWithPopover } from 'common/entity/components/team';
import { SelectTypes } from 'common/components/core/select';
import { SizeEnum } from 'common/enums/UIEnums';
import theme from './IntelliSortTeamSelector.scss';

import intelliSortIds from 'common/tests/intellisort/intelliSortIds.json';

class IntelliSortTeamSelector extends React.PureComponent {
    render() {
        const { teams, selectedTeamId, onTeamChange } = this.props;

        return (
            <SingleTeamSelectWithPopover
                theme={theme}
                teams={teams}
                selectSize={SizeEnum.Medium}
                isClearable={false}
                value={selectedTeamId}
                onChange={onTeamChange}
                selectType={SelectTypes.None}
                className={theme.singleTeamSelector}
                testId={intelliSortIds.teamSelector}
                noMarginBottom
            />
        );
    }
}
export { IntelliSortTeamSelector };
